/**
 * src/components/dashboard/DashboardFooter.tsx
 * Footer meta bar shown at the bottom of the glass panel on the dashboard.
 * Left: system status LED + processing latency. Right: nav links.
 */
export function DashboardFooter() {
  return (
    <div className="dashboard-footer">
      {/* Left — system status */}
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <span
            className="status-dot led-green"
            style={{ background: 'var(--color-success)' }}
            aria-hidden
          />
          <span
            style={{
              fontFamily: 'var(--font-jetbrains-mono)',
              fontSize: 10,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              color: 'var(--color-mono-dim)',
            }}
          >
            System Online
          </span>
        </div>
        <span
          style={{
            fontFamily: 'var(--font-jetbrains-mono)',
            fontSize: 10,
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            color: 'var(--color-mono-dim)',
            opacity: 0.4,
          }}
        >
          Processing Latency: 24ms
        </span>
      </div>

      {/* Right — nav links */}
      <div className="flex items-center gap-3">
        <FooterLink label="Dashboard" />
        <Divider />
        <FooterLink label="Archive" />
        <Divider />
        <FooterLink label="Support" />
      </div>
    </div>
  );
}

function FooterLink({ label }: { label: string }) {
  return (
    <button
      style={{
        background: 'none',
        border: 'none',
        fontFamily: 'var(--font-jetbrains-mono)',
        fontSize: 10,
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        color: 'var(--color-mono-dim)',
        opacity: 0.5,
        cursor: 'pointer',
        padding: 0,
        transition: 'opacity 150ms',
      }}
      onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.opacity = '1'; }}
      onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.opacity = '0.5'; }}
    >
      {label}
    </button>
  );
}

function Divider() {
  return (
    <span style={{ color: 'var(--color-mono-dim)', opacity: 0.3, fontSize: 10, fontFamily: 'var(--font-jetbrains-mono)' }}>
      /
    </span>
  );
}
